const data = {
  id: 1,
  title: 'Choose the most correct sentence among 4 sentences below.',
  subTitle: 'Chọn câu đúng nhất trong các câu dưới đây.',
  audio: '',
  answers: [
    { id: 1, answer: 'They cook for diner everyday.', isCorrect: true, audio: '' },
    { id: 2, answer: 'They cooking for diner everyday.', isCorrect: false, audio: '' },
    { id: 3, answer: 'They cooked for diner everyday.', isCorrect: false, audio: '' },
    { id: 4, answer: 'They cooks for diner everyday.', isCorrect: false, audio: '' },
  ],
};

export default data;
